import React, { useState } from 'react';
import { Platform, TextInput, View } from 'react-native';
import Text from '@/components/Typography/Text';
import useBusinessBrand from './businessBrand';
import useBusinessEnrollment from './useBusinessEnrollment';
import { BUSINESS_SEATS, BUSINESS_MIN_SEATS, BUSINESS_MAX_SEATS, businessCopy, businessMoney, businessNumber, estimateBusinessSeats } from '@/constants/businessContent';

export default function BusinessSeatCalculator() {
  const c = useBusinessBrand();
  const copy = businessCopy(useBusinessEnrollment());
  const [quantities, setQuantities] = useState({ plus: '8', premium: '2' });
  const estimate = estimateBusinessSeats(Object.fromEntries(Object.entries(quantities).map(([key, value]) => [key, /^\d+$/.test(value) ? Number(value) : NaN])));
  if (Platform.OS !== 'web') return null;
  return (
    <View style={{ padding: 28, borderWidth: 1, borderColor: c.rule, borderRadius: 16, gap: 24, width: '100%' }}>
      <Text tag="h2" weight="semibold" style={{ color: c.ink, fontSize: 24 }}>Plan your team</Text>
      {BUSINESS_SEATS.map(seat => (
        <View key={seat.id} style={{ flexDirection: 'row', alignItems: 'center', gap: 16 }}>
          <View style={{ flex: 1, gap: 6 }}>
            <Text weight="semibold" style={{ color: c.ink, fontSize: 16 }}>{seat.label}</Text>
            <Text style={{ color: c.muted, fontSize: 14, lineHeight: 21 }}>{businessMoney(seat.priceCents)} / seat / month{ '\n' }{businessNumber(seat.credits)} credits per seat</Text>
          </View>
          <TextInput
            accessibilityLabel={`${seat.label} seats`}
            accessibilityHint={`Whole seats from 0 to ${BUSINESS_MAX_SEATS}`}
            inputMode="numeric"
            value={quantities[seat.id]}
            maxLength={3}
            onChangeText={value => setQuantities(current => ({ ...current, [seat.id]: value }))}
            style={{ width: 72, minHeight: 48, padding: 12, fontSize: 18, textAlign: 'center', color: c.ink, backgroundColor: c.page, borderColor: c.edge, borderWidth: 1, borderRadius: 8 }}
          />
        </View>
      ))}
      <View accessibilityLiveRegion="polite" style={{ gap: 8, paddingTop: 20, borderTopWidth: 1, borderTopColor: c.rule }}>
        {estimate ? <>
          <Text weight="semibold" style={{ color: c.ink, fontSize: 32 }}>{businessMoney(estimate.priceCents)}<Text style={{ color: c.muted, fontSize: 16 }}> / month</Text></Text>
          <Text style={{ color: c.ink, fontSize: 16 }}>{businessNumber(estimate.credits)} shared credits / month</Text>
          <Text style={{ color: c.muted, fontSize: 14 }}>{estimate.count} seats · Monthly billing · USD</Text>
        </> : <Text style={{ color: c.ink, lineHeight: 24 }}>Enter whole seat counts totaling {BUSINESS_MIN_SEATS}–{BUSINESS_MAX_SEATS} seats.</Text>}
      </View>
      <Text style={{ color: c.muted, fontSize: 13, lineHeight: 21 }}>{copy.calculatorNote}</Text>
    </View>
  );
}
